import { useEffect } from "react";
import { logTrace } from "../services/ApiServices/LoggingService";
import * as rewardsApi from "../services/ApiServices/ApiService";

const QuantumMetrics = () => {
  useEffect(() => {
    getQMUrl();
    async function getQMUrl() {
      const handleError = (error) => {
        logTrace(error, "error when calling rewardsApi.getQMUrl", "getQMUrl in QuantumMetrics.jsx");
      };

      const handleSuccess = (responseData) => { 
        if(responseData != null && responseData !== ""){
          const qtm = document.createElement("script");
          qtm.async = true;
          qtm.src = responseData;
          qtm.className = 'optanon-category-C02';
          qtm.type = 'text/plain';
          
          document.body.appendChild(qtm);
        } 
      };
      await rewardsApi.getQMUrl(handleSuccess, handleError);
    }
     
  }, []);
  
  return <></>;
};

export default QuantumMetrics;

